import React, { useEffect, useState } from "react";

import { getVerificationLogs, getWarrantyList } from "../services/Tools";
import { useNavigate } from "react-router-dom";


const WarrantyList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userid = localStorage.getItem("userId");
    if (!userid) {
      setLoading(false);
      return;
    }
    fetchLogs(userid);
  }, []);

  const fetchLogs = async (userid) => {
    setLoading(true);
    try {
      const res = await getWarrantyList(userid);
      setData(res?.data || []);
    } catch (err) {
      const msg = err?.response?.data?.message || "Failed to load warranty logs";
      message.error(msg);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };


return (
     <div
    style={{
      width: "80vw",
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
      position: "relative",
    }}
  >
    {selectedProduct && (
      <div
        style={{
          background: "#f0f5ff",
          border: "1px solid #d6e4ff",
          borderRadius: "10px",
          padding: "20px 24px",
          marginBottom: "20px",
          position: "relative",
        }}
      >
        <button
          onClick={() => setSelectedProduct(null)}
          style={{
            position: "absolute",
            top: "10px",
            right: "14px",
            background: "none",
            border: "none",
            fontSize: "18px",
            cursor: "pointer",
            color: "#888",
          }}
        >
          &#10005;
        </button>
        <h3 style={{ margin: "0 0 14px", fontSize: "18px", color: "#1677ff" }}>
          Product Details
        </h3>
        <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
          {[
            ["Order No", selectedProduct.orderno],
            ["Scratch No", selectedProduct.scratchno],
            ["Model No", selectedProduct.modelno],
            ["Hologram No", selectedProduct.hologramno],
            ["Warranty Days", selectedProduct.warrantydays],
            ["Start Date", formatDate(selectedProduct.startdate)],
            ["End Date", formatDate(selectedProduct.enddate)],
          ].map(([label, value]) => (
            <div key={label}>
              <div style={{ fontSize: "12px", color: "#888", marginBottom: "2px" }}>{label}</div>
              <div style={{ fontSize: "15px", fontWeight: "600" }}>{value || "-"}</div>
            </div>
          ))}
          {selectedProduct.image1 && (
            <div>
              <div style={{ fontSize: "12px", color: "#888", marginBottom: "2px" }}>Product Image</div>
              <a
                href={selectedProduct.image1}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1677ff", fontWeight: "600", textDecoration: "none" }}
              >
                View Image
              </a>
            </div>
          )}
        </div>
      </div>
    )}

    {loading ? (
      <div style={{ padding: 20, textAlign: "center" }}>Loading...</div>
    ) : (
      <table
        style={{
          width: "1350px",
          minWidth: "1150px",
          borderCollapse: "collapse",
          background: "#fff",
        }}
      >
        <thead>
          <tr>
            {[
              "S.No",
              "Order No",
              "Scratch No",
              "Model No",
              "Hologram No",
              "Warranty Days",
              "Start Date",
              "End Date",
              "Product Image",
              "Action",
            ].map((item) => (
              <th
                key={item}
                style={{
                  border: "1px solid #ddd",
                  background: "#1677ff",
                  color: "#fff",
                  padding: "12px",
                  textAlign: "left",
                  whiteSpace: "nowrap",
                }}
              >
                {item}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr
                key={item.id || index}
                onClick={() => setSelectedProduct(item)}
                style={{
                  cursor: "pointer",
                  background: selectedProduct?.id === item.id ? "#e6f0ff" : index % 2 === 0 ? "#fff" : "#fafafa",
                  transition: "background 0.15s",
                }}
                onMouseEnter={(e) => {
                  if (selectedProduct?.id !== item.id) e.currentTarget.style.background = "#f0f5ff";
                }}
                onMouseLeave={(e) => {
                  if (selectedProduct?.id !== item.id) e.currentTarget.style.background = index % 2 === 0 ? "#fff" : "#fafafa";
                }}
              >
                <td style={cell}>{index + 1}</td>

                <td style={cell}>{item.orderno || "-"}</td>

                <td style={cell}>{item.scratchno || "-"}</td>

                <td style={cell}>{item.modelno || "-"}</td>

                <td style={cell}>{item.hologramno || "-"}</td>

                <td style={cell}>{item.warrantydays || "-"}</td>

                <td style={cell}>{formatDate(item.startdate)}</td>

                <td style={cell}>{formatDate(item.enddate)}</td>

                <td style={cell}>
                  {item.image1 ? (
                    <a
                      href={item.image1}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#1677ff",
                        textDecoration: "none",
                        fontWeight: "500",
                      }}
                    >
                      View
                    </a>
                  ) : (
                    "-"
                  )}
                </td>

                <td style={cell}>
                  <button
                    onClick={() =>
                      navigate("/warrantyClaim", {
                        state: item,
                      })
                    }
                    style={{
                      padding: "6px 16px",
                      background: "#1677ff",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontWeight: "500",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Claim
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={10}
                style={{
                  textAlign: "center",
                  padding: "20px",
                  border: "1px solid #ddd",
                }}
              >
                No warranty logs found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    )}
  </div>
);
};
const cell = {
  border: "1px solid #ddd",
  padding: "10px",
  whiteSpace: "nowrap",
  verticalAlign: "middle",
};
export default WarrantyList;
